import { sectionMarginHeight } from 'common/components/page-section';

interface MoveContentProps {
  movementRef: React.RefObject<HTMLElement>;
  complementsRef?: React.MutableRefObject<HTMLElement | null>;
  newQuantity: number;
  setComplementBlockIsUp: React.Dispatch<React.SetStateAction<boolean>>;
  isFirstTime: boolean;
  setIsFirstTime: React.Dispatch<React.SetStateAction<boolean>>;
  cancelAnimations?: boolean;
  mobile?: boolean;
}

interface MoveUpProps {
  movementRef: React.RefObject<HTMLElement>;
  complementsRef?: React.MutableRefObject<HTMLElement | null>;
  setComplementBlockIsUp: React.Dispatch<React.SetStateAction<boolean>>;
  mobile?: boolean;
}

export const moveUp = ({ complementsRef, movementRef, setComplementBlockIsUp, mobile }: MoveUpProps) => {
  if (complementsRef?.current && movementRef?.current) {
    const complementsHeight = complementsRef?.current?.clientHeight;
    const miscHeight = movementRef?.current?.clientHeight;
    const marginHeight = mobile ? 0 : sectionMarginHeight;
    complementsRef.current.style.transform = `translateY(-${miscHeight}px)`;
    movementRef.current.style.transform = `translateY(${complementsHeight + marginHeight}px)`;
    setComplementBlockIsUp(true);
  }
};

export const moveContent = async ({
  movementRef,
  complementsRef,
  newQuantity,
  setComplementBlockIsUp,
  isFirstTime,
  setIsFirstTime,
  cancelAnimations = false,
  mobile,
}: MoveContentProps) => {
  // we cancel function run if no need in upgrade
  // we cancel animations when the callback is initiated by webcomponent collapse
  if (cancelAnimations) {
    complementsRef?.current?.style.setProperty('transition', 'none', 'important');
  }
  if (newQuantity > 0) {
    setTimeout(() => moveUp({ complementsRef, movementRef, setComplementBlockIsUp, mobile }), 200);
  } else if (newQuantity === 0) {
    if (complementsRef?.current && movementRef?.current) {
      complementsRef.current.style.transform = `translateY(0px)`;
      movementRef.current.style.transform = `translateY(0px)`;
      setComplementBlockIsUp(false);
    }
  }
  if (isFirstTime) setIsFirstTime(false);
  // we return animations when the cancelled animations are meant to be finished
  setTimeout(() => {
    if (cancelAnimations) {
      complementsRef?.current?.style.setProperty('transition', 'all 300ms ease-in-out', 'important');
    }
  }, 300);
};
